/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * CompanyApi - axios parameter creator
 */
export const CompanyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a paged list of all the companies for this company view
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: async (pageSize, currentPage, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v2/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a single ConfigPlatform.Features.Companies.Dtos.CompanyDetailsDto by its id
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById: async (id, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyById', 'id', id);
            const localVarPath = `/v2/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Find a single company by its name
         * @param {string} name
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByName: async (name, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getCompanyByName', 'name', name);
            const localVarPath = `/v2/companies/by-name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a paged list of databases for the specified company.
         * @param {number} id Identifier of the company whose databases are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request and determine database access rights.
         * @param {string} [authVersion] Version of the authorization contract to use when validating the request.
         * @param {string} [companyView] Optional company view identifier used to scope which databases the caller can access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDatabases: async (id, pageSize, currentPage, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyDatabases', 'id', id);
            const localVarPath = `/v2/companies/{id}/databases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the retentions for all the databases from this company
         * @param {number} id The id of the company
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRetentions: async (id, pageSize, currentPage, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyRetentions', 'id', id);
            const localVarPath = `/v2/companies/{id}/databases/retentions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns a list of this company with its children, and all parents of this company you have access to
         * @param {number} id id of the referenced company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTree: async (id, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyTree', 'id', id);
            const localVarPath = `/v2/companies/{id}/tree`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns the direct UNS children for the specified company.  When UNS is enabled for the company, children are queried from the ltree {uns_identifiers} table.  When UNS is disabled, falls back to the MSSQL-based UNS tree so the frontend requires no changes during migration.
         * @param {number} id Identifier of the company whose UNS children are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request.
         * @param {string} [authVersion] Version of the authorization contract to use.
         * @param {string} [companyView] Optional company view identifier used to scope access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUns: async (id, pageSize, currentPage, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUns', 'id', id);
            const localVarPath = `/v2/companies/{id}/uns`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (currentPage !== undefined) {
                localVarQueryParameter['CurrentPage'] = currentPage;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=2.0,application/json; X-Api-Version=2.0,text/json; X-Api-Version=2.0';
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['authVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['companyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompanyApi - functional programming interface
 */
export const CompanyApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a paged list of all the companies for this company view
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a single ConfigPlatform.Features.Companies.Dtos.CompanyDetailsDto by its id
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyById(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyById(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Find a single company by its name
         * @param {string} name
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyByName(name, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyByName(name, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns a paged list of databases for the specified company.
         * @param {number} id Identifier of the company whose databases are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request and determine database access rights.
         * @param {string} [authVersion] Version of the authorization contract to use when validating the request.
         * @param {string} [companyView] Optional company view identifier used to scope which databases the caller can access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyDatabases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the retentions for all the databases from this company
         * @param {number} id The id of the company
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyRetentions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns a list of this company with its children, and all parents of this company you have access to
         * @param {number} id id of the referenced company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyTree(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyTree(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Returns the direct UNS children for the specified company.  When UNS is enabled for the company, children are queried from the ltree {uns_identifiers} table.  When UNS is disabled, falls back to the MSSQL-based UNS tree so the frontend requires no changes during migration.
         * @param {number} id Identifier of the company whose UNS children are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request.
         * @param {string} [authVersion] Version of the authorization contract to use.
         * @param {string} [companyView] Optional company view identifier used to scope access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getUns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CompanyApi - factory interface
 */
export const CompanyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyApiFp(configuration);
    return {
        /**
         *
         * @summary Get a paged list of all the companies for this company view
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a single ConfigPlatform.Features.Companies.Dtos.CompanyDetailsDto by its id
         * @param {number} id
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyById(id, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyById(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find a single company by its name
         * @param {string} name
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByName(name, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyByName(name, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a paged list of databases for the specified company.
         * @param {number} id Identifier of the company whose databases are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request and determine database access rights.
         * @param {string} [authVersion] Version of the authorization contract to use when validating the request.
         * @param {string} [companyView] Optional company view identifier used to scope which databases the caller can access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the retentions for all the databases from this company
         * @param {number} id The id of the company
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of this company with its children, and all parents of this company you have access to
         * @param {number} id id of the referenced company
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyTree(id, authorization, authVersion, companyView, options) {
            return localVarFp.getCompanyTree(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns the direct UNS children for the specified company.  When UNS is enabled for the company, children are queried from the ltree {uns_identifiers} table.  When UNS is disabled, falls back to the MSSQL-based UNS tree so the frontend requires no changes during migration.
         * @param {number} id Identifier of the company whose UNS children are requested.
         * @param {number} [pageSize]
         * @param {number} [currentPage]
         * @param {string} [authorization] Bearer token used to authorize the request.
         * @param {string} [authVersion] Version of the authorization contract to use.
         * @param {string} [companyView] Optional company view identifier used to scope access.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
            return localVarFp.getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyApi - object-oriented interface
 */
export class CompanyApi extends BaseAPI {
    /**
     *
     * @summary Get a paged list of all the companies for this company view
     * @param {number} [pageSize]
     * @param {number} [currentPage]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanies(pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a single ConfigPlatform.Features.Companies.Dtos.CompanyDetailsDto by its id
     * @param {number} id
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyById(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyById(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find a single company by its name
     * @param {string} name
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyByName(name, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyByName(name, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a paged list of databases for the specified company.
     * @param {number} id Identifier of the company whose databases are requested.
     * @param {number} [pageSize]
     * @param {number} [currentPage]
     * @param {string} [authorization] Bearer token used to authorize the request and determine database access rights.
     * @param {string} [authVersion] Version of the authorization contract to use when validating the request.
     * @param {string} [companyView] Optional company view identifier used to scope which databases the caller can access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyDatabases(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the retentions for all the databases from this company
     * @param {number} id The id of the company
     * @param {number} [pageSize]
     * @param {number} [currentPage]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyRetentions(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of this company with its children, and all parents of this company you have access to
     * @param {number} id id of the referenced company
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyTree(id, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getCompanyTree(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns the direct UNS children for the specified company.  When UNS is enabled for the company, children are queried from the ltree {uns_identifiers} table.  When UNS is disabled, falls back to the MSSQL-based UNS tree so the frontend requires no changes during migration.
     * @param {number} id Identifier of the company whose UNS children are requested.
     * @param {number} [pageSize]
     * @param {number} [currentPage]
     * @param {string} [authorization] Bearer token used to authorize the request.
     * @param {string} [authVersion] Version of the authorization contract to use.
     * @param {string} [companyView] Optional company view identifier used to scope access.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options) {
        return CompanyApiFp(this.configuration).getUns(id, pageSize, currentPage, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
}
